/** Check whether a node is a valid element.
 * From https://github.com/facebook/draft-js/blob/e869fcb5bd3bdc8982fde497a14c0e59e7c2ae97/src/component/utils/isElement.js
 *  */
export var isElement = function isElement(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  return node.nodeType === Node.ELEMENT_NODE;
};
export var isHTMLElement = function isHTMLElement(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  if (!node.ownerDocument.defaultView) {
    return node instanceof HTMLElement;
  }

  if (node instanceof node.ownerDocument.defaultView.HTMLElement) {
    return true;
  }

  return false;
};